import './App.css';
import React from 'react';
import Menu from './components/Menu';
import SignUp from './accounts/SignUp';   
import SignIn from './accounts/SignIn';
import ServiceList from './services/services';
import ServiceLoggedin from './services/servicesloggedin';
import ServiceCustomerDetails from './services/servicecustomerdetails';
import SignOut from './accounts/SignOut';   
import Profile from './settings/Profile';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ServicesCRUD from './vendors/Services';
import ServiceDetails from './vendors/ServiceDetails';
import VendorSignup from './vendors/VendorSignup'; 
import VendorSignupFull from './vendors/VendorSignupFull'; 
import VendorSignUpNext from './vendors/VendorSignUpNext';
import VendorSignUpConfirmation from './vendors/VendorSignupConfirmation';
import VendorSignupVerification from './vendors/VendorSignUpVerification'; 
import AppointmentPage from './appointments/appointments';
import SearchVendors from './appointments/search';
import ForgotPassword from './accounts/forgotpassword';
import ResetPassword from './accounts/resetpassword';
import VerifyToken from './accounts/verifytoken';
import PasswordConfirmation from './accounts/passwordconfirmation';
import Photos from './photos/Photos';
import AddressPage from './settings/adddress';
import VendorAppointments from './vendors/VendorAppointments';
import VendorDashboard from './vendors/VendorDashboard';
import CustomerRatings from './ratings/customerratings';
import HelpPage from './settings/HelpPage';
import ErrorPage from './settings/ErrorPage';
import About from './settings/About';
import Footer from './components/Footer';
import VendorSchedules from './vendors/VendorSchedules';
import VendorScheduleUpdates from './vendors/VendorScheduleUpdates';
import VendorSelection from './vendors/VendorSelection';
import VendorRatings from './vendors/VendorRatings';
import VendorDetails from './vendors/VendorDetails';
import ServiceAppointments from './services/serviceappointments';
import CustomerDashboard from './services/customerdashboard';
import Invoices from './invoices/invoices';
import PayInvoice from './invoices/payinvoice';
import Invoicedetails from './invoices/invoicedetails';
import AppointmentLinks from './vendors/appointmentlinks';
import Mail from './inbox/mail';
import Inbox from './inbox/inbox';
import MailDetails from './inbox/maildetails';
import AdminPage from './admin/AdminPage';
import VendorDescription from './vendors/VendorDescription';
import VendorInvoices from './vendors/VendorInvoices';
import ReplyMail from './inbox/replymail';
import UnAuthorized from './admin/UnAuthorized';
import ContactUs from './settings/ContactUs';
import Feedback from './settings/Feedback';
import VendorFeedback from './admin/Feedback';
import CreditCards from './settings/CreditCards';
import VendorCashOut from './vendors/VendorCashOut'; // Add this import
import MoneyOut from './admin/MoneyOut';
import AIPage from './ai/AIPage';

function App() {
  return (
    <Router>
      <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <Menu />
        <div style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<ServiceList />} />
            <Route path="/home" element={<ServiceList />} />
            <Route path="/search" element={<ServiceLoggedin />} />
            <Route path="/signin" element={<SignIn />} />
            <Route path="/signup" element={<SignUp />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/logout" element={<SignOut />} />
            <Route path="/services" element={<ServicesCRUD />} />
            <Route path="/service_customer_details/:id" element={<ServiceCustomerDetails />} />
            <Route path="/services_details/:id" element={<ServiceDetails />} />
            <Route path="/vendorsignup" element={<VendorSignup />} />
            <Route path="/vendorsignupfull" element={<VendorSignupFull />} />
            <Route path="/vendorsignupnext" element={<VendorSignUpNext />} />
            <Route path="/vendorsignupconfirmation" element={<VendorSignUpConfirmation />} />
            <Route path="/vendorsignupverification" element={<VendorSignupVerification />} />
            <Route path="/appointments" element={<AppointmentPage />} />
            <Route path="/search_vendors/:productId" element={<SearchVendors />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verifytoken" element={<VerifyToken />} />
            <Route path="/passwordconfirmation" element={<PasswordConfirmation />} />
            <Route path="/photos" element={<Photos />} />
            <Route path="/adddress" element={<AddressPage />} />
            <Route path="/vendorappointments" element={<VendorAppointments />} />
            <Route path="/vendordashboard" element={<VendorDashboard />} />
            <Route path="/customerratings/:vendor_id/:product_detail_id/:appointment_id" element={<CustomerRatings />} />
            <Route path="/help" element={<HelpPage />} />
            <Route path="/error" element={<ErrorPage />} />
            <Route path="/about" element={<About />} />
            <Route path="/vendorschedules" element={<VendorSchedules />} />
            <Route path="/vendorscheduleupdates" element={<VendorScheduleUpdates />} />
            <Route path="/vendorselection/:serviceDetailId" element={<VendorSelection />} />
            <Route path="/vendorratings" element={<VendorRatings />} />
            <Route path="/vendordetails/:vendor_id" element={<VendorDetails />} />
            <Route path="/serviceappointments/:id" element={<ServiceAppointments />} />
            <Route path="/ai" element={<AIPage />} />
            <Route path="/customerdashboard" element={<CustomerDashboard />} />
            <Route path="/invoices" element={<Invoices customer_id />} />
            <Route path="/payinvoice/:id" element={<PayInvoice />} />
            <Route path="/invoicedetails/:id" element={<Invoicedetails />} />
            <Route path="/appointmentlinks" element={<AppointmentLinks />} />
            <Route path="/mail" element={<Mail />} />
            <Route path="/inbox" element={<Inbox />} />
            <Route path="/maildetails/:id" element={<MailDetails />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/vendordescription" element={<VendorDescription />} />
            <Route path="/vendorinvoices" element={<VendorInvoices />} />
            <Route path="/replymail" element={<ReplyMail />} />
            <Route path="/unauthorized" element={<UnAuthorized />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/admin/feedback" element={<VendorFeedback />} />
            <Route path="/creditcards" element={<CreditCards />} />
            <Route path="/vendorcashout" element={<VendorCashOut />} /> {/* Add this route */}
            <Route path="/moneyout" element={<MoneyOut />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;